import __var_0__ from '@stdlib/utils/constant-function';
import __var_1__ from '@stdlib/math/base/assert/is-nan';
import __var_2__ from '@stdlib/math/base/assert/is-integer';
import __var_3__ from '@stdlib/constants/math/float64-sqrt-two';
import __var_4__ from '@stdlib/math/base/special/pow';
import __var_5__ from '@stdlib/math/base/tools/normhermitepoly';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var constantFunction = __var_0__;
var isnan = __var_1__;
var isint = __var_2__;
var SQRT2 = __var_3__;
var pow = __var_4__;
var normhermitepoly = __var_5__;


// MAIN //

/**
* Returns a function for evaluating a physicist's Hermite polynomial.
*
* @param {NonNegativeInteger} n - polynomial degree
* @returns {Function} function for evaluating a physicist's Hermite polynomial
*
* @example
* var polyval = factory( 2 );
*
* var v = polyval( 0.5 );
* // returns -1.0
*/
function factory( n ) {
	var c;
	if ( n < 0 || isnan( n ) || !isint( n ) ) {
		return constantFunction( NaN );
	}
	if ( n === 0 ) {
		return constantFunction( 1.0 );
	}
	c = pow( 2.0, 0.5*n );
	return polyval;

	/**
	* Evaluates a physicist's Hermite polynomial.
	*
	* @private
	* @param {number} x - value at which to evaluate a physicist's Hermite polynomial
	* @returns {number} result
	*/
	function polyval( x ) {
		return c * normhermitepoly( n, SQRT2*x );
	}
}


// EXPORTS //
export default factory;
